// extracted by mini-css-extract-plugin
export default {"nameWrapper":"style_nameWrapper__P6rXU","label":"style_label__mrdB2","hidden":"style_hidden__9h95g","root":"style_root__YkXS5"};